// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3f3a_","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1zyqn"};